
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Banner',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  setup() {
  },
})
